export default __webpack_public_path__ + "static/media/User_Edit_off.3fd58b5a.svg";